// import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
import { DataGrid, GridOverlay } from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import React from 'react';

function TabPanel({
  children,
  value,
  index,
  ...other
}) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.defaultProps = {
  children: {},
  index: 0,
  value: 0,
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number,
  value: PropTypes.number,
};
function CustomizedNoRowsOverlay() {
  return (
    <GridOverlay>
      <Box display="flex" flexDirection="column" alignItems="center">
        <h1 className="text-2xlfont-gothambook">No results have been returned</h1>
        {/* <h1 className="mt-1 mb-5 text-sm font-bold text-stone-700">Change search parameter or</h1>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          sx={{
            borderRadius: '20px',
            width: 150,
            height: 40,
            backgroundColor: '#384451',
          }}
          onClick={onAddNewUser}
        >
          Add Attribute
        </Button> */}
      </Box>
    </GridOverlay>
  );
}

function Attributes({
  columns, rows, onChangePageSize, rowsPerPage, pageAmount, totalRows, CustomPagination, onChangeSelectedPage, openEditModal,
  selectedPage,
}) {
  return (
    <DataGrid
      rows={rows}
      columns={columns}
      getRowId={(row) => row.ProductAttributeDefId}
      className="bg-white"
      sx={{
        '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
        '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
        '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
      }}
      onRowClick={(params) => openEditModal(params.row)}
      slots={{
        noRowsOverlay: (() => CustomizedNoRowsOverlay()),
        pagination: () => CustomPagination(selectedPage, onChangeSelectedPage, rowsPerPage, onChangePageSize, pageAmount, totalRows),
      }}
      style={{ height: rows.length === 0 ? 200 : '100%' }}
      rowsPerPageOptions={[15, 30, 50, 100, 200, 400, 600, 800, 1000]}
    />
  );
}

export default Attributes;
